import * as React from "react";

import { Button } from "@/components/ui/button";
import type { PendingCounts } from "../editor/editorHandle";
import { plural } from "./helpers";

interface Props {
  counts: PendingCounts | null;
  disabled?: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
}

export const PendingChanges: React.FC<Props> = ({ counts, disabled, onAcceptAll, onRejectAll }) => {
  if (!counts || (counts.changes === 0 && counts.comments === 0)) return null;
  return (
    <section
      aria-label="Pending changes"
      className="flex items-center justify-between gap-3 border-b border-desert-sand-300 px-4 py-3"
    >
      <div>
        <p className="text-sm text-ui-heading-text">
          {plural(counts.changes, "change", "changes")} to review
          {counts.comments > 0 && `, ${plural(counts.comments, "comment", "comments")}`}
        </p>
        {counts.changes > 0 && (
          <p className="text-xxs text-gray-500">Accepting or rejecting can be undone with Ctrl+Z until you save.</p>
        )}
      </div>
      {counts.changes > 0 && (
        <div className="flex shrink-0 gap-2">
          <Button size="sm" onClick={onAcceptAll} disabled={disabled}>
            Accept all
          </Button>
          <Button size="sm" variant="outline" onClick={onRejectAll} disabled={disabled}>
            Reject all
          </Button>
        </div>
      )}
    </section>
  );
};
